import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ShieldCheck, Navigation, ChevronRight } from "lucide-react";

// Compact entry card used on Home & Safety. Shows active journey status if any.
export const JourneyCard = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState(null);

  useEffect(() => {
    api
      .get("/journeys/active")
      .then((r) => setActive(r.data && r.data.id ? r.data : null))
      .catch(() => setActive(null));
  }, []);

  const emergency = active?.status === "emergency";

  return (
    <button
      data-testid="journey-entry-card"
      onClick={() => navigate("/journey")}
      className={`w-full text-left rounded-3xl p-5 shadow-lg active:scale-[0.99] transition-transform relative overflow-hidden ${
        emergency
          ? "bg-[#DC2626] text-white"
          : "bg-[#0E7C66] text-white"
      }`}
    >
      <div className="absolute -right-6 -top-8 w-32 h-32 rounded-full bg-white/10" />
      <div className="absolute -right-2 top-10 w-20 h-20 rounded-full bg-white/10" />
      <div className="relative flex items-center gap-3">
        <div className="w-11 h-11 rounded-2xl bg-white/20 flex items-center justify-center shrink-0">
          <ShieldCheck className="w-6 h-6" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-black text-lg leading-tight">Guardian Journey</p>
          {active ? (
            <p className="text-sm text-white/85 truncate flex items-center gap-1">
              <Navigation className="w-3.5 h-3.5" />
              {active.status_label} · to {active.destination}
            </p>
          ) : (
            <p className="text-sm text-white/85">
              Let a trusted circle watch over your trip
            </p>
          )}
        </div>
        <ChevronRight className="w-5 h-5 shrink-0" />
      </div>
      {active && (
        <div className="relative mt-4 h-1.5 rounded-full bg-white/25 overflow-hidden">
          <div
            className="h-full bg-white rounded-full transition-all"
            style={{ width: `${Math.round((active.progress || 0) * 100)}%` }}
          />
        </div>
      )}
    </button>
  );
};
